import { createApi } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS_CONSTANTS } from "../constants/endpointConstants";
import baseQueryWithReauth from "./baseQuery";

export const salaryService = createApi({
  reducerPath: "salaryService",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    postSalary: builder.mutation({
      invalidatesTags: ["SALARY"],
      query: ({ payload }) => {
        return {
          url: ENDPOINTS_CONSTANTS.SALARY,
          method: "POST",
          body: payload,
          headers: {
            "content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    multiPostSalary: builder.mutation({
      invalidatesTags: ["SALARY"],
      query: ({ payload }) => {
        return {
          url: ENDPOINTS_CONSTANTS.MULTI_SALARY,
          method: "POST",
          body: payload,
          headers: {
            "content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    modifySalary: builder.mutation({
      invalidatesTags: ["SALARY"],
      query: ({ payload, id }) => {
        return {
          url: `${ENDPOINTS_CONSTANTS.SALARY}/${id}`,
          method: "PUT",
          body: payload,
          headers: {
            "content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    deleteSalary: builder.mutation({
      invalidatesTags: ["SALARY"],
      query: (id) => {
        return {
          url: `${ENDPOINTS_CONSTANTS.SALARY}/${id}`,
          method: "DELETE",
          headers: {
            "content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getSalary: builder.query({
      query: () => ({
        url: ENDPOINTS_CONSTANTS.SALARY,
        method: "GET",
      }),
    }),
    getEmployee: builder.query({
      providesTags: ["SALARY"],
      query: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return {
          url: `${ENDPOINTS_CONSTANTS.EMPLOYEE_SALARY}?${queryString}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetSalaryQuery,
  useMultiPostSalaryMutation,
  useLazyGetEmployeeQuery,
  useModifySalaryMutation,
  useDeleteSalaryMutation,
  usePostSalaryMutation,
} = salaryService;
